<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
</script>

<template>
    <main>
        <div class="ktg-main-container">
            <h1 class="ktg-title-01 mb-3rem">{{ $t('hilfe_amp_kontakt') }}</h1>
            <nav class="mb-5">
                <ktg-tabs>
                    <RouterLink :to="{ name: 'help-faq' }" custom v-slot="{ isActive, navigate }">
                        <ktg-tab :active="isActive || null" @activate="navigate">{{
                            $t('fragen_amp_antworten')
                        }}</ktg-tab>
                    </RouterLink>
                    <RouterLink :to="{ name: 'help-contact' }" custom v-slot="{ isActive, navigate }">
                        <ktg-tab :active="isActive || null" @activate="navigate">{{
                            $t('kontakt')
                        }}</ktg-tab>
                    </RouterLink>
                </ktg-tabs>
            </nav>
        </div>
        <RouterView></RouterView>
    </main>
</template>
